<template>
  <div class="list">
      <div class="list-item" :key="index" v-for="(item, index) in videoList">
      <video-show :videoList="videoList" :selectedIndex="index" :video="item"/>
    </div>
    </div>
</template>

<script>
// import native from '@zz-common/native-adapter'
// import { Toast } from '@zz-common/zz-ui'
// import { lego } from '@zz-common/lego'
// import setPicSize from '@zz-app/setPicSize'
import VideoShow from '../Home/VideoPlayer/Video';

export default {
  name: 'video-list',
  data() {
    return {
      videoList: this.$route.query.videoList || []
    }
  },
  components: {
    VideoShow
  }
}
</script>

<style scoped lang="less">
  @import 'index.less';
</style>